import { render } from "./VideoView.vue?vue&type=template&id=26aaec36"
import script from "./VideoView.vue?vue&type=script&lang=js"
export * from "./VideoView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ranjanbajracharya/Documents/Upwork/kaz/panorama/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__